module.exports = __webpack_public_path__ + "static/media/Sport-Wales-bilingual-Colour-logo.21850865.png";